import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchNotifications, markNotificationsRead } from "../actions/notificationsActions";

const initialState: NotificationsState = {
  notifications: [],
  unreadCount: 0,
  status: 'idle',  // 'idle' | 'pending' | 'succeeded' | 'failed'
  error: null,

};

const notificationsSlice = createSlice({
  name:'notifications',
  initialState,
  reducers:{
    setUnreadNotificationsCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    decrementUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = Math.max(0, state.unreadCount - action.payload);

  },
  markNotificationsLocally: (state, action: PayloadAction<number[]>) => {
    action.payload.forEach(idToMark => {
      const notification = state.notifications.find(n => n.id === idToMark);
      if (notification) {
        notification.is_read = true;
      }
    });
  }
},
    

  extraReducers: builder =>{
    getNotificationsBuilder(builder);
    markNotificationsReadBuilder(builder);
 
  },

});

const getNotificationsBuilder = (builder: ActionReducerMapBuilder<NotificationsState>) =>{
builder.addCase(fetchNotifications.pending, (state) => {
  state.status = 'pending';
  state.error = null;
});
builder.addCase(fetchNotifications.fulfilled, (state, action:PayloadAction<NotificationType[]>)=>{
  state.status = 'succeeded';
  state.notifications = action.payload;
  state.error= null;
  state.unreadCount = action.payload.filter(n => !n.is_read).length;

});
builder.addCase(fetchNotifications.rejected, (state, action) =>
{
  state.status = 'failed';
  state.error = action.payload || 'failed to fetch notifications';
  state.notifications = [];
  state.unreadCount = 0;
});
};

const markNotificationsReadBuilder = (builder: ActionReducerMapBuilder<NotificationsState>) => {
  builder.addCase(markNotificationsRead.pending, (state) =>{
  state.status = 'pending';
  state.error = null;

  });
  builder.addCase(markNotificationsRead.fulfilled, (state, action:PayloadAction<number[]>) =>{
    state.status = 'succeeded';
    const markedIds = action.payload;
    state.notifications.forEach(notification => {
      if (markedIds.includes(notification.id)) {
        notification.is_read = true;
      } 
    });
    state.unreadCount = Math.max(0, state.unreadCount - markedIds.length);
      
    state.error = null; 

  });
  builder.addCase(markNotificationsRead.rejected, (state, action) =>{
    state.status = 'failed';
    console.error('Failed to mark notifications as read:', action.payload);

  });
};

export const { setUnreadNotificationsCount, decrementUnreadCount, markNotificationsLocally } = notificationsSlice.actions;
export default notificationsSlice.reducer;
